import { render, staticRenderFns } from "./JobItemContent.vue?vue&type=template&id=7ba2abca&scoped=true"
import script from "./JobItemContent.vue?vue&type=script&lang=ts"
export * from "./JobItemContent.vue?vue&type=script&lang=ts"
import style0 from "./JobItemContent.vue?vue&type=style&index=0&id=7ba2abca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2abca",
  null
  
)

export default component.exports